export const RESET_NOTIFICATION_BADGE = "RESET_NOTFICATION_BADGE";
